import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { company } from '@/data/company';
import { partners } from '@/data/partners';
import { solutions } from '@/data/solutions';
import { services } from '@/data/services';

const StatsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const stats = [
    { value: String(company.foundedYear), label: 'Established in Amman' },
    { value: 'Grade A', label: 'E/M and civil works' },
    { value: String(services.length), label: 'Published service sectors' },
    { value: String(solutions.length), label: 'Solution lines' },
    { value: String(partners.length), label: 'Technology partners' },
    { value: 'Regional', label: 'Jordan and beyond' },
  ];

  return (
    <section ref={ref} className="py-24 relative bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="relative bg-gradient-to-br from-[#398024]/5 to-[#398024]/10 border border-[#398024]/20 rounded-3xl p-12 md:p-16"
        >
          <div className="text-center mb-16">
            <h2 className="text-sm font-semibold text-[#398024] tracking-wider uppercase mb-3">At a glance</h2>
            <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Facts from the MAYAN profile
            </h3>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={isInView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center"
              >
                <div className="text-4xl md:text-5xl font-bold text-[#398024] mb-2">{stat.value}</div>
                <div className="text-gray-600 text-sm md:text-base font-medium">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default StatsSection;
